// extracted by mini-css-extract-plugin
export default {"wrapper":"IconAndLabel_wrapper__9HAep","icon":"IconAndLabel_icon__cOlqk","label":"IconAndLabel_label__7i0Yi"};